import Nullstack from 'nullstack';
export default function IconPizzaOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-pizza-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10.313 6.277l1.687 -3.277l5.34 10.376m2.477 6.463a19.093 19.093 0 0 1 -7.817 1.661c-3.04 0 -5.952 -.714 -8.5 -1.983l5.434 -10.559"
  }), "   ", Nullstack.element("path", {
    d: "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634c1.56 .002 3.105 -.24 4.582 -.713"
  }), "   ", Nullstack.element("path", {
    d: "M11 14v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}